import { Box, Button, Grid, Typography } from "@material-ui/core"
import { Check, Close, FileCopy } from "@material-ui/icons"
import { useSnackbar } from "notistack"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom/cjs/react-router-dom"
import logoCF from "../../assets/icon-512x512.png"
import { getFatura } from "../../services/comum"
import useLoadingStore from "../../stores/LoadingStore"

export function Faturas() {
    const setLoading = useLoadingStore(s => s.setLoading)
    const { idFatura } = useParams()
    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const [fatura, setFatura] = useState(null)

    const copiarCodigoPix = () => {
        const texto = fatura?.qrCodePixText
        if (!texto) return
        navigator.clipboard.writeText(texto).then(
            () => alertStart("Código PIX copiado!", "success"),
            () => alertStart("Não foi possível copiar.", "error")
        )
    }

    const faturaPix = async () => {
        setLoading(true)
        try {
            const response = await getFatura(idFatura)

            if (response.retornoErro === 1) {
                console.log(response.mensagem)
                alertStart(response.mensagem, "error")
            } else {
                setFatura(response)
            }
        } catch (error) {
            console.log(error)
            alertStart(error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        document.title = "Cliente Fiel - Fatura"
        return () => { document.title = "Sistema de Aceitar Pedidos - Cliente Fiel" }
    }, [])

    useEffect(() => {
        faturaPix()
    }, [])

    const valorFormatado = fatura?.valor != null
        ? fatura.valor.toFixed(2).replace(".", ",")
        : "0,00"
    const vencimentoFormatado = fatura?.dataVencimento
        ? (() => {
            const [ano, mes, dia] = fatura.dataVencimento.split("-")
            return `${dia}/${mes}/${ano}`
        })()
        : ""

    return (
        <div style={{ backgroundColor: "#f5f5f5", minHeight: "100vh", paddingBottom: "2em", paddingLeft: "1em", paddingRight: "1em", boxSizing: "border-box" }}>
            {fatura && (
                <Grid
                    style={{ margin: "auto", marginTop: "2em", maxWidth: 960, width: "100%" }}
                    xs={11}
                    md={10}
                    lg={10}
                    container
                    spacing={2}
                >
                    <Grid xs={12} md={6} lg={6} item>
                        <Box style={{ textAlign: "center", marginBottom: "1.5em" }}>
                            <img src={logoCF} alt="Cliente Fiel" style={{ height: 90, width: 90 }} />
                        </Box>
                        <Box
                            style={{
                                backgroundColor: "white",
                                padding: "1.25em",
                                borderRadius: "12px",
                                boxShadow: "0px 0px 5px rgba(0,0,0,0.08)",
                                marginBottom: "1em",
                                marginLeft: "0.5em",
                                marginRight: "0.5em",
                                boxSizing: "border-box",
                            }}
                        >
                            <p style={{ margin: "0 0 0.5em 0", lineHeight: 1.6 }}>
                                Vendido por: <span style={{ fontWeight: "bold" }}>Cliente Fiel</span>
                            </p>
                            <p style={{ margin: "0 0 0.5em 0", lineHeight: 1.6 }}>
                                CNPJ: <span style={{ fontWeight: "bold" }}>09.309.505/0001-07</span>
                            </p>
                            <p style={{ margin: 0, lineHeight: 1.6 }}>
                                Comprador: <span style={{ fontWeight: "bold" }}>{fatura?.nomeEstabelecimento}</span>
                            </p>
                        </Box>
                        <Box
                            style={{
                                backgroundColor: "white",
                                padding: "1.25em",
                                borderRadius: "12px",
                                boxShadow: "0px 0px 5px rgba(0,0,0,0.08)",
                                marginLeft: "0.5em",
                                marginRight: "0.5em",
                                boxSizing: "border-box",
                            }}
                        >
                            <h4 style={{ textAlign: "center", margin: "0 0 1em 0", fontWeight: "bold" }}>
                                Detalhamento
                            </h4>
                            <p style={{ margin: "0 0 0.5em 0" }}>
                                ID da fatura: <span style={{ fontWeight: "bold" }}>{fatura?.id}</span>
                            </p>
                            <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "0.75em 0" }} />
                            <p style={{ margin: "0 0 0.25em 0", fontWeight: "bold" }}>{fatura?.descricao}</p>
                            <p style={{ margin: "0 0 0.25em 0" }}>Quantidade: 1</p>
                            <p style={{ margin: "0 0 0.25em 0" }}>
                                Valor unitário: R$ {valorFormatado}
                            </p>
                            <p style={{ margin: "0 0 0.5em 0", fontWeight: "bold" }}>Subtotal: R$ {valorFormatado}</p>
                            <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "0.75em 0" }} />
                            <Box style={{ display: "flex", justifyContent: "space-between", marginBottom: "0.25em" }}>
                                <span>Subtotal</span>
                                <span>R$ {valorFormatado}</span>
                            </Box>
                            <Box style={{ display: "flex", justifyContent: "space-between", marginBottom: "0.5em", fontWeight: "bold" }}>
                                <span>Total</span>
                                <span>R$ {valorFormatado}</span>
                            </Box>
                            <p style={{ margin: 0, fontWeight: "bold" }}>Vencimento: {vencimentoFormatado}</p>
                            <p style={{ margin: "0.5em 0 0 0", fontSize: "0.9em", color: "#666" }}>
                                Status: <span style={{ fontWeight: "bold" }}>{fatura?.status}</span>
                            </p>
                        </Box>
                    </Grid>
                    <Grid xs={12} md={6} lg={6} item>
                        <Box
                            style={{
                                backgroundColor: "white",
                                padding: "1.25em",
                                borderRadius: "12px",
                                boxShadow: "0px 0px 5px rgba(0,0,0,0.08)",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                marginLeft: "0.5em",
                                marginRight: "0.5em",
                                boxSizing: "border-box",
                            }}
                        >
                            <h4 style={{ textAlign: "center" }}>Pagamento via PIX</h4>
                            <hr />
                            {fatura?.status === "CANCELADA" ? (
                                <div style={{ height: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "2em 0" }}>
                                    <Close
                                        style={{ width: "120px", height: "120px", color: "#c62828" }}
                                    />
                                    <Typography style={{ fontWeight: "bold", fontSize: "1.4em", marginTop: "0.5em", color: "#c62828", textAlign: "center" }}>
                                        Fatura cancelada
                                    </Typography>
                                </div>
                            ) : fatura?.status !== "ABERTA" ? (
                                <div style={{ height: "100%", display: "flex" }}>
                                    <Grid
                                        xs={12}
                                        md={6}
                                        lg={6}
                                        style={{
                                            textAlign: "center",
                                            margin: "auto",
                                        }}
                                    >
                                        <Check
                                            style={{
                                                width: "150px",
                                                height: "150px",
                                                color: "green",
                                            }}
                                        />
                                        <Typography
                                            style={{ fontWeight: "bold", fontSize: "1.4em" }}
                                        >
                                            Pagamento realizado
                                        </Typography>
                                    </Grid>
                                </div>
                            ) : (
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <Box
                                        style={{
                                            margin: "24px auto",
                                            padding: "24px",
                                            maxWidth: "220px",
                                            textAlign: "center",
                                        }}
                                    >
                                        <img
                                            src={fatura?.qrCodePix}
                                            alt="QR Code PIX"
                                            style={{ width: "100%", height: "auto", display: "block" }}
                                        />
                                    </Box>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        startIcon={<FileCopy />}
                                        onClick={copiarCodigoPix}
                                        disabled={fatura.status === "PAGA"}
                                    >
                                        Copiar código PIX
                                    </Button>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                        style={{ marginTop: "1.5em", textAlign: "center", maxWidth: 320, lineHeight: 1.6 }}
                                    >
                                        O Pix é uma modalidade de transferência automática que funciona 24h por dia e possui confirmação imediata.
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                        style={{ marginTop: "0.5em", textAlign: "center", maxWidth: 320, lineHeight: 1.6 }}
                                    >
                                        Procure em seu aplicativo de banco ou conta digital essa funcionalidade e escaneie o QR Code disponível ou copie o código utilizando a opção de &quot;Pix Copia e Cola&quot; para efetivar um pagamento.
                                    </Typography>
                                </div>
                            )}
                        </Box>
                    </Grid>
                </Grid>
            )}
        </div>
    )
}
